import React, {useEffect, useRef, useState} from 'react';
import moment from "moment";
import Translate from "../../../../../../../components/Translate";
import TranslateProperty from "../../../../../../../components/TranslateProperty";
import {filterInputStyle} from "../../../../../../../utils/General";
import Input from "../../../../../../../components-new/Input";
import ResetButton from "../../../../../../../components-new/buttons/ResetButton";
import ExcelButton from "../../../../../../../components-new/buttons/ExcelButton";
import {
    generateOperatorsLoginLogoutExcel,
    getOperatorsLoginLogoutData
} from "../../../../../../../services/statistics/api";
import TableHeaderSort from "../../../../../../../components-new/Table/TableHeaderSort";
import TablePagination from "../../../../../../../components/TablePagination";
import LoadingComponent from "../../../../../../../assets/LoadingComponent";

const OperatorsLoginLogoutTable = ({company}) => {

    const [filters, setFilters] = useState({
        parentCompanyId: company.id,
        start: '',
        end: '',
        operator: ''
    })

    const [pageable, setPageable] = useState({
        page: 0,
        size: 5,
        sort: 'actionTime,desc'
    });

    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [isFetching, setIsFetching] = useState(false);
    const [operatorActoins, setOperatorActions] = useState([]);
    const [operatorSearchValue, setOperatorSearchValue] = useState('')

    const [isFetchingExcel,setIsFetchingExcel] = useState(false);

    let updateFilterOnSearchChange = useRef(false);

    useEffect(() => {
        fetchData();
    }, [pageable.page, pageable.size, pageable.sort, filters]);

    useEffect(() => {

        // without this logic on reset filters makes 2 api calls
        if (!updateFilterOnSearchChange.current) {
            updateFilterOnSearchChange.current = true;
            return
        }

        const timeout = setTimeout(() => {
            updateFilter('operator', operatorSearchValue);
        }, 300)

        return () => {
            clearTimeout(timeout);
        }
    }, [operatorSearchValue])

    function updateFilter(key, val) {
        setPageable({
            ...pageable,
            page: 0
        })
        setFilters({
            ...filters,
            [key]: val
        })
    }

    function fetchData() {
        setIsFetching(true);

        getOperatorsLoginLogoutData(filters, pageable).then((result) => {
            if (result && result.content && result.pageable) {
                setOperatorActions(result.content)
                setTotalElements(result.totalElements)
                setTotalPages(result.totalPages === 0 ? 1 : result.totalPages)
            } else {
                setOperatorActions([])
                setTotalElements(0)
                setTotalPages(1)
            }
        }).catch(e => {
            setOperatorActions([])
            setTotalElements(0)
            setTotalPages(1)
        }).finally(() => {
            setIsFetching(false);
        })
    }

    function handleSort(column) {
        if (!column) return

        const sort = pageable.sort;
        let newSort
        let currentColumn, currentOrder

        if (sort) {
            currentOrder = sort.split(',').pop();
            currentColumn = sort.split(',').slice(0, -1).join(',');
        }

        if (currentOrder && currentColumn === column) {
            newSort = column + ',' + (currentOrder === 'asc' ? 'desc' : 'asc');
        } else {
            newSort = column + ',' + 'asc'
        }

        setPageable({
            ...pageable,
            sort: newSort,
        });

    }

    function resetFilters() {
        updateFilterOnSearchChange.current = false
        setOperatorSearchValue('')

        setPageable({
            ...pageable,
            page: 0
        })

        setFilters({
            ...filters,
            start: '',
            end: '',
            operator: ''
        })
    }

    const exportToExcel = () => {
        setIsFetchingExcel(true);
        generateOperatorsLoginLogoutExcel("Operators login-logout", filters)
                                            .finally(() => {
                                                setIsFetchingExcel(false);
                                            });
    }

    const headers = [
        {text: 'operator', sortColumn: 'operator.firstName,operator.lastName'},
        {text: 'actionType', sortColumn: 'actionType'},
        {text: 'time', sortColumn: 'actionTime'},
        {text: 'IP', sortColumn: 'ipAddress'},
        {text: 'browser', sortColumn: 'userAgent'},
    ]

    return (
        <div>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                marginBottom: '16px',
                flexWrap: 'wrap',
            }}>
                <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                    <TranslateProperty properties={[{
                        key: 'placeholder',
                        value: 'searchByOperator'
                    }]}>
                        <input
                            type="text"
                            value={operatorSearchValue}
                            onChange={(e) => setOperatorSearchValue(e.target.value)}
                            style={{...filterInputStyle, width: '300px'}}
                        />
                    </TranslateProperty>

                    <Input
                        className={'calendar-select'}
                        style={{width: '240px', height: '40px'}}
                        type="date"
                        value={filters.start}
                        onChange={e => updateFilter('start', e.target.value)}
                    />
                    <Input
                        className={'calendar-select'}
                        style={{width: '240px', height: '40px'}}
                        type="date"
                        value={filters.end}
                        onChange={e => updateFilter('end', e.target.value)}
                    />

                    {
                        (filters.start !== '' || filters.end !== '' || filters.operator !== '')
                        &&
                        <ResetButton
                            onClick={resetFilters}
                            width={150}
                            height={40}
                            variant="outline"
                        />
                    }

                </div>

                <div>
                    <ExcelButton
                        onClick={exportToExcel}
                        width={190}
                        height={40}
                        variant="outline"
                        loading={isFetchingExcel}
                        children={
                            <span style={{fontSize: '14px', backgroundColor: 'transparent'}}>
                                        <Translate text={'downloadXls'}/>
                                    </span>
                        }
                    />
                </div>
            </div>

            <div style={{
                overflowX: 'auto',
                maxHeight: '600px',
                minHeight: '300px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}>
                <table className={"custom-table"}>
                    <thead>
                    <tr style={{textAlign: 'left', background: '#f4f4f4'}}>
                        {
                            headers.map((header, index) => (
                                <th key={index}
                                    onClick={() => handleSort(header.sortColumn)}
                                >
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: index === 0 ? 'start' : 'center',
                                        gap: '10px'
                                    }}>
                                        {
                                            header.text === 'IP' ? 'IP' : <Translate text={header.text}/>
                                        }
                                        <TableHeaderSort
                                            isActive={pageable.sort.split(',').slice(0, -1).join(',') === header.sortColumn}
                                            direction={pageable.sort.split(',').pop()}
                                        />
                                    </div>
                                </th>
                            ))
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {
                        (isFetching) ? (
                                <tr>
                                    <td colSpan="100%" style={{padding: '50px 0'}}><LoadingComponent/></td>
                                </tr>
                            ) :
                            <React.Fragment>
                                {
                                    operatorActoins.map((item) => (
                                        <tr key={item.id + item.actionTime}>
                                            <td>{item.operator ? (item.operator.firstName + " " + item.operator.lastName) : "N/A"}</td>
                                            <td style={{textAlign: 'center'}}><Translate text={item.actionType}/></td>
                                            <td style={{textAlign: 'center'}}>
                                                {moment(item.actionTime).format('YYYY-MM-DD HH:mm:ss')}
                                            </td>
                                            <td style={{textAlign: 'center'}}>{item.ipAddress}</td>
                                            <td style={{textAlign: 'center'}}>
                                                {
                                                    item.userAgent.includes('Chrome') && !item.userAgent.includes('Edge') && !item.userAgent.includes('OPR')
                                                        ? 'Chrome'
                                                        : item.userAgent.includes('Firefox')
                                                            ? 'Firefox'
                                                            : item.userAgent.includes('Safari') && !item.userAgent.includes('Chrome')
                                                                ? 'Safari'
                                                                : item.userAgent.includes('Edge')
                                                                    ? 'Edge'
                                                                    : item.userAgent.includes('OPR') || item.userAgent.includes('Opera')
                                                                        ? 'Opera'
                                                                        : item.userAgent.includes('MSIE') || item.userAgent.includes('Trident')
                                                                            ? 'Internet Explorer'
                                                                            : <Translate text={'other'}/>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </React.Fragment>
                    }

                    {
                        operatorActoins.length === 0 && !isFetching &&
                        <tr>
                            <td colSpan="100%" style={{textAlign: 'center', padding: '40px', color: '#6c757d'}}>
                                <Translate text={'noResultsFound'}/>
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>

            <div style={{
                display: 'flex',
                flexShrink: 0,
                padding: '10px 0',
                backgroundColor: '#fff',
                justifyContent: 'flex-end',
                alignItems: 'center',
            }}>

                <TablePagination
                    totalRows={totalElements}
                    numberOfPages={totalPages}
                    handleChangeRowsPerPage={(size) => setPageable({...pageable, size})}
                    rowsPerPage={pageable.size}
                    curPage={pageable.page}
                    selectPage={(page) => setPageable({...pageable, page})}
                />
            </div>

        </div>
    );
};

export default OperatorsLoginLogoutTable;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/components/operators/OperatorsLoginLogoutTable.jsx